import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import LocationPage from "@/pages/LocationPage";
import ServicePage from "@/pages/ServicePage";
import Guides from "@/pages/Guides";
import GuidePage from "@/pages/GuidePage";

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/service-areas/:slug" element={<LocationPage />} />
                        <Route path="/services/:slug" element={<ServicePage />} />
                        <Route path="/guides" element={<Guides />} />
                        <Route path="/guides/:slug" element={<GuidePage />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </BrowserRouter>
            </HelmetProvider>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#16281D",
                        color: "#F8FAF9",
                        border: "1px solid #233D2D",
                    },
                }}
            />
        </div>
    );
}

export default App;
